import { AutocompleteInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

const options = [
  'Ongehuwd en niet wettelijk samenwonend',
  'Gehuwd',
  'Wettelijk samenwonend',
  'Van tafel en bed gescheiden',
  'Weduwnaar/weduwe',
  'Uit de echt gescheiden/beëindiging wettelijk samenwonend',
];

export default function Step() {
  return (
    <StepWrapper
      name="Burgerlijke staat"
      forwardStep={(data) => {
        if (data['burgerlijke_staat'] === 'Gehuwd') {
          return 1;
        }

        if (data['burgerlijke_staat'] === 'Wettelijk samenwonend') {
          return 2;
        }

        return 4;
      }}
    >
      <Grid container spacing={4}>
        <AutocompleteInput
          name="burgerlijke_staat"
          options={options.map((x) => ({
            text: x,
            value: x,
          }))}
          label="Burgerlijke staat"
          required
        />
      </Grid>
    </StepWrapper>
  );
}
